// extracted by mini-css-extract-plugin
export default {"selectedValue":"DropdownSelect_selectedValue__IuQR3","ant-dropdown-menu":"DropdownSelect_ant-dropdown-menu__SDv5m","selectedValueAuth":"DropdownSelect_selectedValueAuth__K5THQ"};